
import { Component } from '@angular/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  title = 'pmu-beauty-forms-web';

  // The company name for an artist
  companyName:string
  constructor (
  ) {        
  }
  
}
